import { FC } from 'react';

import TableSingleVacancy from '../../../components/table/recruiting/tableVacancySingle';

import styles from './singleVacancy.module.scss';

const SingleVacancy: FC = () => {
	return (
		<div className={styles.vacancyCreateWrapper}>
			<TableSingleVacancy />
		</div>
	);
};

export default SingleVacancy;
